module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-page-wrapper"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.appointment.title_appointmemt')) + "\n    "), _c('div', {
    staticClass: "views-wrapper d-none d-md-block"
  }, [_c('div', {
    staticClass: "form-group has-feedback has-search event-filt event-filt-input search-input"
  }, [_c('span', {
    staticClass: "fa fa-search form-control-feedback",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_searchs),
      expression: "filter_searchs"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.appointment.filter_search')
    },
    domProps: {
      "value": (_vm.filter_searchs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_searchs = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openNewAppointmentForm(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.appointment.add_appointment')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openExportCriteria
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.appointment.export_appointments')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [(!_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.viewType === 'daily'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('daily')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.daily_view')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq",
    class: {
      'btn-primary': _vm.viewType === 'monthly'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('monthly')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.monthly_view')))]), _vm._v(" "), (_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.viewType === 'weekly'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('weekly')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.weekly_view')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq-right",
    class: {
      'btn-primary': _vm.viewType === 'list'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.list_view')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "time-wrapper d-none d-md-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "event-wrapper d-none d-md-block"
  }, [_c('div', {
    staticClass: "event-filters"
  }, [_c('div', {
    staticClass: "switch-time-btn event-filt"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_calendar_view),
      expression: "!show_calendar_view"
    }],
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [_c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.filter_date_type === 'all'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchTime('all')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.filter_date_all')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq-right",
    class: {
      'btn-primary': _vm.filter_date_type === 'range'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchTime('range')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.filter_date_range')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filter_date_type === 'range' && !_vm.show_calendar_view),
      expression: "filter_date_type === 'range' && !show_calendar_view"
    }],
    staticClass: "filter-date event-filt"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    class: {
      'inactive': _vm.filter_date_type == 'all'
    },
    attrs: {
      "placeholder": _vm.$t('message.appointment.filter_date_range_placeholder'),
      "config": {
        mode: 'range'
      },
      "id": "filter-date-range"
    },
    model: {
      value: (_vm.filter_date_range),
      callback: function($$v) {
        _vm.filter_date_range = $$v
      },
      expression: "filter_date_range"
    }
  })], 1), _vm._v(" "), (_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_doctor",
      "placeholder": _vm.$t('message.appointment.filter_doctor'),
      "options": _vm.doctor_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "loading": _vm.doctorLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getDoctorsOptions
    },
    model: {
      value: (_vm.filter_by_doctors),
      callback: function($$v) {
        _vm.filter_by_doctors = $$v
      },
      expression: "filter_by_doctors"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_clinic",
      "placeholder": _vm.$t('message.appointment.filter_clinic'),
      "options": _vm.clinic_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "loading": _vm.clinicLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getClinicsOptions
    },
    model: {
      value: (_vm.filter_by_clinics),
      callback: function($$v) {
        _vm.filter_by_clinics = $$v
      },
      expression: "filter_by_clinics"
    }
  }) : _vm._e(), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_status",
      "placeholder": _vm.$t('message.appointment.filter_status'),
      "options": _vm.status_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.filter_by_status_list),
      callback: function($$v) {
        _vm.filter_by_status_list = $$v
      },
      expression: "filter_by_status_list"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu d-sm-block d-md-none"
  }, [_c('div', [_c('div', {
    staticClass: "form-group has-feedback has-search event-filt event-filt-input search-input"
  }, [_c('span', {
    staticClass: "fa fa-search form-control-feedback",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_searchs),
      expression: "filter_searchs"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.appointment.filter_search')
    },
    domProps: {
      "value": (_vm.filter_searchs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_searchs = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openNewAppointmentForm(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.appointment.add_appointment')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-block btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openExportCriteria
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.appointment.export_appointments')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [(!_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.viewType === 'daily'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('daily')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.daily_view')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq",
    class: {
      'btn-primary': _vm.viewType === 'monthly'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('monthly')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.monthly_view')))]), _vm._v(" "), (_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.viewType === 'weekly'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('weekly')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.weekly_view')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq-right",
    class: {
      'btn-primary': _vm.viewType === 'list'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.list_view')))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "switch-time-btn event-filt"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_calendar_view),
      expression: "!show_calendar_view"
    }],
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [_c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.filter_date_type === 'all'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchTime('all')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.filter_date_all')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq-right",
    class: {
      'btn-primary': _vm.filter_date_type === 'range'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchTime('range')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.filter_date_range')))])])])]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filter_date_type === 'range' && !_vm.show_calendar_view),
      expression: "filter_date_type === 'range' && !show_calendar_view"
    }],
    staticClass: "filter-date event-filt"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    class: {
      'inactive': _vm.filter_date_type == 'all'
    },
    attrs: {
      "placeholder": _vm.$t('message.appointment.filter_date_range_placeholder'),
      "config": {
        mode: 'range'
      },
      "id": "filter-date-range"
    },
    model: {
      value: (_vm.filter_date_range),
      callback: function($$v) {
        _vm.filter_date_range = $$v
      },
      expression: "filter_date_range"
    }
  })], 1)]), _vm._v(" "), _c('div', [(_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_doctor",
      "placeholder": _vm.$t('message.appointment.filter_doctor'),
      "options": _vm.doctor_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "loading": _vm.doctorLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getDoctorsOptions
    },
    model: {
      value: (_vm.filter_by_doctors),
      callback: function($$v) {
        _vm.filter_by_doctors = $$v
      },
      expression: "filter_by_doctors"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.$guser.isDoctor()) ? _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_clinic",
      "placeholder": _vm.$t('message.appointment.filter_clinic'),
      "options": _vm.clinic_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "loading": _vm.clinicLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getClinicsOptions
    },
    model: {
      value: (_vm.filter_by_clinics),
      callback: function($$v) {
        _vm.filter_by_clinics = $$v
      },
      expression: "filter_by_clinics"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_status",
      "placeholder": _vm.$t('message.appointment.filter_status'),
      "options": _vm.status_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.filter_by_status_list),
      callback: function($$v) {
        _vm.filter_by_status_list = $$v
      },
      expression: "filter_by_status_list"
    }
  })], 1)]), _vm._v(" "), (_vm.show_calendar_view && _vm.calendarLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-5 col-md-2"
  }, [_c('dot-loader', {
    attrs: {
      "loading": _vm.calendarLoading,
      "size": "60px"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_calendar_view),
      expression: "show_calendar_view"
    }],
    staticClass: "scheduler-box"
  }, [(_vm.processEventLoading && !_vm.calendarLoading) ? _c('div', {
    staticClass: "scheduler-indicator-box"
  }, [_c('div', {
    staticClass: "scheduler-indicator"
  }, [_c('dot-loader', {
    attrs: {
      "size": "60px"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scheduler"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_calendar_view),
      expression: "!show_calendar_view"
    }]
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.paginator.from) + " - " + _vm._s(_vm.paginator.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.paginator.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.rows')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.prev_page_url && _vm.refreshAppointmentList(_vm.paginator.prev_page_url, _vm.paginator.current_page - 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.next_page_url && _vm.refreshAppointmentList(_vm.paginator.next_page_url, _vm.paginator.current_page + 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.patient')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.doctor_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.latest_reminded_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.patient_status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.appointment_status')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.display_appointments), function(app) {
    return _c('tr', {
      key: app
    }, [_c('td', [_vm._v(_vm._s(app.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayAppointmentDate(app.start)) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.displayAppointmentTime(app.start, app.object.duration)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(app.object.firstname) + " " + _vm._s(app.object.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(app.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayAppointmentDateTime(app.object.latest_reminded_time)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(app.object.patient_status != 'inactive') ? _c('i', {
      staticClass: "fa fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (app.object.patient_status_3hr != 'inactive') ? _c('i', {
      staticClass: "fa fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (app.object.patient_status == 'inactive') ? _c('i', {
      staticClass: "fa fa-minus text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (app.object.patient_status_3hr == 'inactive') ? _c('i', {
      staticClass: "fa fa-minus text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('dropdown', {
      attrs: {
        "text": app.object.status,
        "type": _vm.getDropdownType(app.object.status),
        "disabled": app.object.status == 'cancel'
      }
    }, [(app.object.status !== 'scheduled') ? _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-success",
      on: {
        "click": function($event) {
          _vm.changeStatus(app.id, 'scheduled')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_scheduled')))])]) : _vm._e(), _vm._v(" "), (app.object.status === 'scheduled' && app.object.patient_status === 'inactive') ? _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-success",
      on: {
        "click": function($event) {
          _vm.changeStatus(app.id, 'patient_confirm')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_patient_confirm')))])]) : _vm._e(), _vm._v(" "), (app.object.status === 'scheduled' && app.object.patient_status_3hr === 'inactive') ? _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-success",
      on: {
        "click": function($event) {
          _vm.changeStatus(app.id, 'patient_confirm_3hr')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_patient_confirm_3hr')))])]) : _vm._e(), _vm._v(" "), (app.object.status !== 'pending' && app.object.status !== 'checkin') ? _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-success",
      on: {
        "click": function($event) {
          _vm.changeStatus(app.id, 'checkin')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_checkin')))])]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-danger",
      on: {
        "click": function($event) {
          _vm.cancelAppointment(app.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_cancel')))])])])], 1), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "btn btn-sm fa fa-edit",
      on: {
        "click": function($event) {
          _vm.editAppointment(app)
        }
      }
    }, [_c('small', [_vm._v(" " + _vm._s(_vm.$t('action_message.edit')))])])])])
  }), _vm._v(" "), (_vm.display_appointments.length === 0 && _vm.appointmentLoaded && !_vm.appointmentLoading) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.appointment.no_appointment_with_filter')))])])]) : _vm._e(), _vm._v(" "), (_vm.appointmentLoading) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.appointmentLoading),
      expression: "appointmentLoading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])]) : _vm._e()], 2)])]), _vm._v(" "), _c('sweet-modal', {
    ref: "exportCriteriaModel"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', [_vm._v("เลือกวันที่")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 offset-3"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.appointment.filter_date_range_placeholder'),
      "config": {
        mode: 'range'
      },
      "id": "export_date_range"
    },
    model: {
      value: (_vm.export_date_range),
      callback: function($$v) {
        _vm.export_date_range = $$v
      },
      expression: "export_date_range"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 custom-field-wrap"
  }, [_c('a', {
    staticClass: "custom-field",
    on: {
      "click": function($event) {
        _vm.openedExportFields = !_vm.openedExportFields
      }
    }
  }, [_vm._v("Custom fields")])]), _vm._v(" "), (_vm.openedExportFields) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form', [_vm._l((_vm.exportFields), function(field) {
    return _c('div', {
      key: field.id,
      staticClass: "form-check form-check-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedExportFieldIds),
        expression: "selectedExportFieldIds"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "id": "inlineCheckboxs1"
      },
      domProps: {
        "value": field.id,
        "checked": Array.isArray(_vm.selectedExportFieldIds) ? _vm._i(_vm.selectedExportFieldIds, field.id) > -1 : (_vm.selectedExportFieldIds)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedExportFieldIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = field.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selectedExportFieldIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedExportFieldIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedExportFieldIds = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": "inlineCheckbox1"
      }
    }, [_vm._v(_vm._s(field.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasCustomSlot),
      expression: "hasCustomSlot"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "inlineCheckboxs1"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.hasCustomSlot) ? _vm._i(_vm.hasCustomSlot, true) > -1 : (_vm.hasCustomSlot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.hasCustomSlot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.hasCustomSlot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.hasCustomSlot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hasCustomSlot = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineCheckbox1"
    }
  }, [_vm._v("Fixed Slot เวลา (นาที)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slot),
      expression: "slot"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100px",
      "display": "inline-block"
    },
    attrs: {
      "type": "text",
      "id": "หสนะ",
      "placeholder": "เลือก",
      "disabled": !_vm.hasCustomSlot
    },
    domProps: {
      "value": (_vm.slot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.slot = $event.target.value
      }
    }
  })])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.exportCurrentApponitments
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.ok')))])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "remarkModal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('remark-editor', {
    attrs: {
      "valueRemarks": _vm.templates.remark_templates
    },
    on: {
      "update:valueRemarks": function($event) {
        _vm.templates.remark_templates = $event
      },
      "closeEditor": _vm.closeRemarkModal,
      "submitRemark": _vm.updateRemarks,
      "comment-updated": function($event) {
        _vm.updateComment($event)
      }
    }
  })], 1), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.editMode) ? _c('h4', [_vm._v(_vm._s(_vm.$t('message.appointment.title_edit')))]) : _c('h4', [_vm._v(_vm._s(_vm.$t('message.appointment.title_add')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 confirm-btn-group"
  }, [(_vm.appointment.status) ? _c('dropdown', {
    staticClass: "confirm-btn-lg",
    attrs: {
      "text": _vm.appointment.status,
      "type": _vm.getDropdownType(_vm.appointment.status),
      "disabled": _vm.appointment.status == 'cancel'
    }
  }, [(_vm.appointment.status !== 'checkin') ? _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-success",
    on: {
      "click": function($event) {
        _vm.appointment.status = 'scheduled'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_scheduled')))])]) : _vm._e(), _vm._v(" "), (_vm.appointment.status !== 'pending' && _vm.appointment.status !== 'checkin') ? _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-success",
    on: {
      "click": function($event) {
        _vm.appointment.status = 'checkin'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_checkin')))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        _vm.appointment.status = 'cancel '
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_cancel')))])])]) : _vm._e()], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": _vm.fpConfig,
      "required": ""
    },
    model: {
      value: (_vm.appointment.appointment_time),
      callback: function($$v) {
        _vm.appointment.appointment_time = $$v
      },
      expression: "appointment.appointment_time"
    }
  }), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": _vm.$t('message.appointment.doctor_placeholder'),
      "options": _vm.doctor_options,
      "loading": _vm.doctorLoading,
      "allow-empty": true,
      "disabled": _vm.appointment.status === 'cancel',
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getDoctorsOptions
    },
    model: {
      value: (_vm.appointment.doctor),
      callback: function($$v) {
        _vm.appointment.doctor = $$v
      },
      expression: "appointment.doctor"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.doctorIdError
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_type),
      expression: "patient_type"
    }],
    ref: "patient_type_b",
    attrs: {
      "type": "radio",
      "name": "patient_type",
      "value": "exists",
      "disabled": _vm.appointment.status === 'cancel'
    },
    domProps: {
      "checked": _vm._q(_vm.patient_type, "exists")
    },
    on: {
      "__c": function($event) {
        _vm.patient_type = "exists"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.appointment.old_patient')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_type),
      expression: "patient_type"
    }],
    ref: "patient_type_a",
    attrs: {
      "type": "radio",
      "name": "patient_type",
      "value": "noexists",
      "disabled": _vm.appointment.status === 'cancel'
    },
    domProps: {
      "checked": _vm._q(_vm.patient_type, "noexists")
    },
    on: {
      "__c": function($event) {
        _vm.patient_type = "noexists"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.appointment.new_patient')) + "\n        ")])])]), _vm._v(" "), (_vm.patient_type == "exists") ? _c('div', [_c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "patient",
      "placeholder": _vm.$t('message.appointment.search_patient_placeholder'),
      "options": _vm.patient_list,
      "allow-empty": true,
      "disabled": _vm.appointment.status === 'cancel',
      "loading": _vm.patientLoading,
      "internal-search": false,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getPatients
    },
    model: {
      value: (_vm.selected_patient),
      callback: function($$v) {
        _vm.selected_patient = $$v
      },
      expression: "selected_patient"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "prefix",
      "placeholder": this.$t('message.appointment.prefix_placeholder'),
      "options": _vm.prefix_options,
      "allow-empty": true,
      "disabled": _vm.appointment.status === 'cancel',
      "readonly": _vm.existing_patient,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.prefix),
      callback: function($$v) {
        _vm.appointment.prefix = $$v
      },
      expression: "appointment.prefix"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.existing_patient,
      "placeholder": _vm.$t('message.appointment.firstname_placeholder'),
      "required": "",
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.firstname),
      callback: function($$v) {
        _vm.appointment.firstname = $$v
      },
      expression: "appointment.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.firstnameError
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.existing_patient,
      "placeholder": _vm.$t('message.appointment.lastname_placeholder'),
      "required": "",
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.lastname),
      callback: function($$v) {
        _vm.appointment.lastname = $$v
      },
      expression: "appointment.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.lastnameError
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 phone-box"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "phone",
      "readonly": _vm.existing_patient,
      "disabled": _vm.appointment.status === 'cancel'
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.phoneError
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "type": "email",
      "readonly": _vm.existing_patient,
      "placeholder": _vm.$t('message.appointment.email_placeholder'),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.email),
      callback: function($$v) {
        _vm.appointment.email = $$v
      },
      expression: "appointment.email"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.emailError
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('bs-input', {
    attrs: {
      "readonly": _vm.existing_patient,
      "placeholder": _vm.$t('message.appointment.hn'),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.hn),
      callback: function($$v) {
        _vm.appointment.hn = $$v
      },
      expression: "appointment.hn"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "locale",
      "placeholder": _vm.$t('message.appointment.locale_placeholder'),
      "options": _vm.locale_options,
      "allow-empty": false,
      "disabled": _vm.appointment.status === 'cancel',
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.locale),
      callback: function($$v) {
        _vm.appointment.locale = $$v
      },
      expression: "appointment.locale"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "service",
      "placeholder": _vm.$t('message.appointment.service_placeholder'),
      "options": _vm.service_options,
      "allow-empty": true,
      "disabled": _vm.appointment.status === 'cancel',
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.changeAppointmentService
    },
    model: {
      value: (_vm.appointment.service),
      callback: function($$v) {
        _vm.appointment.service = $$v
      },
      expression: "appointment.service"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('bs-input', {
    staticClass: "input-min",
    attrs: {
      "type": "Number",
      "min": "10",
      "max": "1440",
      "step": 5,
      "placeholder": _vm.$t('message.appointment.duration_placeholder'),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.duration),
      callback: function($$v) {
        _vm.appointment.duration = _vm._n($$v)
      },
      expression: "appointment.duration"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.appointment.duration_unit')))])])])], 1)]), _vm._v(" "), (_vm.appointment.comment) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.addition')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appointment.comment))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_vm._l((_vm.templates.remark_templates), function(rt) {
    return _c('button', {
      key: rt.name,
      staticClass: "btn btn-secondary btn-sm btn-remark-template",
      attrs: {
        "type": "button",
        "disabled": _vm.appointment.status === 'cancel'
      },
      on: {
        "click": function($event) {
          _vm.appendRemark(rt.text)
        }
      }
    }, [_vm._v(_vm._s(rt.name))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm btn-success",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openRemarkEditor($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])], 2), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ("" + (_vm.$t('message.appointment.remark_placeholder'))),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.remark),
      callback: function($$v) {
        _vm.appointment.remark = $$v
      },
      expression: "appointment.remark"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('bs-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ("" + (_vm.$t('message.appointment.admin_remark'))),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.admin_note),
      callback: function($$v) {
        _vm.appointment.admin_note = $$v
      },
      expression: "appointment.admin_note"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.sms_feedback_to_patient),
      expression: "appointment.sms_feedback_to_patient"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment.sms_feedback_to_patient) ? _vm._i(_vm.appointment.sms_feedback_to_patient, null) > -1 : (_vm.appointment.sms_feedback_to_patient)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appointment.sms_feedback_to_patient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.appointment.sms_feedback_to_patient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.appointment.sms_feedback_to_patient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment.sms_feedback_to_patient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("ส่ง Sms ถาม Feedback หลังมารักษา")])])])]), _vm._v(" "), (_vm.appointment.status) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewAppointmentDetail(_vm.appointment.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.view_more')))])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.closeAppointmentModal
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.close')))]), _vm._v(" "), (_vm.appointment.status !== 'cancel') ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.saveAppointment($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.save')))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1), _vm._v(" "), (_vm.editMode && _vm.appointment.status !== 'cancel') ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-action",
    on: {
      "click": function($event) {
        _vm.cancelAppointment(_vm.appointment.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.cancel_appointment')))]) : _vm._e()])])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "dateModal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', {
    staticClass: "date-form"
  }, [_c('label', [_vm._v("Select a date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.dateConfig,
      "placeholder": "Select date",
      "name": "date"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "title": "Toggle",
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }, [_c('span', {
    staticClass: "sr-only",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Toggle")])])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotoDate($event)
      }
    }
  }, [_vm._v("Ok")])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "smsConfirmModalForCalendar",
    staticClass: "sms-confirm-modal",
    attrs: {
      "icon": "info",
      "title": "ยืนยันการเปลี่ยนแปลงนัดหมาย?"
    },
    on: {
      "close": function($event) {
        _vm.cancelUpdateAppointmentTime()
      }
    }
  }, [_vm._v("\n    คุณแน่ใจว่าต้องการเปลี่ยนแปลงนัดหมาย?\n    "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateReq.sms_confirmation),
      expression: "updateReq.sms_confirmation"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "defaultCheck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.updateReq.sms_confirmation) ? _vm._i(_vm.updateReq.sms_confirmation, "") > -1 : (_vm.updateReq.sms_confirmation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.updateReq.sms_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.updateReq.sms_confirmation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.updateReq.sms_confirmation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.updateReq.sms_confirmation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "defaultCheck1"
    }
  }, [_vm._v("\n        ส่ง SMS ยืนยันไปที่คนไข้\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.updateAppointmentTime(_vm.updateReq, true)
      }
    },
    slot: "button"
  }, [_vm._v("ยืนยัน")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.$refs.smsConfirmModalForCalendar.close()
      }
    },
    slot: "button"
  }, [_vm._v("ยกเลิก")])]), _vm._v(" "), _c('sweet-modal', {
    ref: "smsConfirmModalForFormChange",
    staticClass: "sms-confirm-modal",
    attrs: {
      "icon": "info",
      "title": "ยืนยันการเปลี่ยนแปลงนัดหมาย?"
    }
  }, [_vm._v("\n    คุณแน่ใจว่าต้องการเปลี่ยนแปลงนัดหมาย?\n    "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateReq.sms_confirmation),
      expression: "updateReq.sms_confirmation"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "defaultCheck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.updateReq.sms_confirmation) ? _vm._i(_vm.updateReq.sms_confirmation, "") > -1 : (_vm.updateReq.sms_confirmation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.updateReq.sms_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.updateReq.sms_confirmation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.updateReq.sms_confirmation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.updateReq.sms_confirmation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "defaultCheck1"
    }
  }, [_vm._v("\n        ส่ง SMS ยืนยันไปที่คนไข้\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.confirmAppointmentFormChange(_vm.updateReq)
      }
    },
    slot: "button"
  }, [_vm._v("ยืนยัน")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.$refs.smsConfirmModalForFormChange.close()
      }
    },
    slot: "button"
  }, [_vm._v("ยกเลิก")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62fd5eee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/appointment/AppointmentCalendar.vue
// module id = 1020
// module chunks = 1